/* eslint-disable */

var ProductAvailability = require('./productavailability');
var ProductAvailabilityType = require('./productavailabilitytype');
var uiSettings = require("./utils/UISettings");

var resolveByCountry = require('@dc/ui-library/src/helpers/environment').resolveByCountry;

var API = {
    /** @param {Product} product */
    /** @param {string} location */
    /** @param {function(data : ProductAvailability)} onsuccess */
    /** @param {function(error : string)} onerror */
    getProductAvailability : function(product, location, onsuccess, onerror){
        console.log("Checking Availability for:", product.getIdentifier(), "At:", location);

        var url;
        if(!location.postcode) {
            url = this.prepareXhrUrl(
                API.PRODUCT_AVAILABILITY_CHECK_URL_NO_POSTCODE, location, product.getIdentifier()
            );
        } else {
            url = this.prepareXhrUrl(
                API.PRODUCT_AVAILABILITY_CHECK_URL, location, product.getIdentifier()
            );
        }

        $.ajax({
            url: url,
            cache: true,
            dataType : "json",
            error: onerror,
            success: function(result) {
                try {
                    if(result.status === "success"){
                      if(result.data.postCodeCheck.storeState === "UNCOLLECTABLE_POSTCODE") {
                        uiSettings.set("app.availability.default", 'delivery', uiSettings.Type.PAGE);
                      } else if(result.data.configuration["app.availability.default"]) {
                        uiSettings.set("app.availability.default", result.data.configuration["app.availability.default"], uiSettings.Type.PAGE);
                      }
                      onsuccess(new ProductAvailability(result.data, location));
                    } else {
                        onerror(result.data.message);
                    }
                } catch (e) {
                    console.error(e);
                    onerror(e);
                }
            }
        });
    },

    /** @param {Array<strings>} productIds */
    /** @param {string} location */
    /** @param {function(data : Array<ProductAvailabilityType>)} onsuccess */
    /** @param {function(error : string)} onerror */
    getProductAvailabilities : function(productIds, location, onsuccess, onerror){
        var data = {
            productIds : productIds
        };

        var url;
        if(!location.postcode) {
            url = this.prepareXhrUrl(API.PRODUCT_AVAILABILITIES_CHECK_URL_NO_POSTCODE, location);
        } else {
            url = this.prepareXhrUrl(API.PRODUCT_AVAILABILITIES_CHECK_URL, location);
        }

        $.ajax({
            url: url,
            type : "POST",
            method : "POST",
            data : JSON.stringify(data),
            contentType: "application/json",
            dataType : "json",
            error: onerror,
            success: function(result) {
                try {
                    if(result.status === "success") {
                        var availabilities = [];
                        for(var i = 0; i < result.data.postcodeResults.length; i++){
                            availabilities.push(new ProductAvailabilityType(
                                result.data.postcodeResults[i],
                                location.postcode));
                        }
                        if(availabilities.length > 0){
                            onsuccess(availabilities);
                        } else {
                            onerror("No Results")
                        }
                    } else {
                        onerror(result.data.message);
                    }
                } catch (e) {
                    console.error(e);
                    onerror(e);
                }
            }
        });
    },

    prepareXhrUrl: function(url, location, productIdentifier) {
        var decimals = 1000000; // 6 decimals because also Brain stores 6 decimals.

        url = url.replace('$POSTCODE', location.postcode.replace(' ', ''));
        if(location.coords && location.coords.length === 2) {
            url = url
                .replace('$LATITUDE', '' + Math.round(location.coords[0] * decimals) / decimals)
                .replace('$LONGITUDE', '' + Math.round(location.coords[1] * decimals) / decimals);
        }

        if(productIdentifier) {
            url = url.replace('$PRODUCT', productIdentifier);
        }

        return url;
    }
};

var countryPrefix = resolveByCountry('/gb/uk/', '/ie/en/');

/** @const */
API.PRODUCT_AVAILABILITY_CHECK_URL = countryPrefix + "mcd_postcode_check/sProductId/$PRODUCT/sPostCode/$POSTCODE/latitude/$LATITUDE/longitude/$LONGITUDE/ajax.html";
API.PRODUCT_AVAILABILITY_CHECK_URL_NO_POSTCODE = countryPrefix + "mcd_postcode_check/sProductId/$PRODUCT/latitude/$LATITUDE/longitude/$LONGITUDE/ajax.html";

/** @const */
API.PRODUCT_AVAILABILITIES_CHECK_URL = countryPrefix + "mcd_multi_postcode_check/postcode/$POSTCODE/latitude/$LATITUDE/longitude/$LONGITUDE/ajax.html";
API.PRODUCT_AVAILABILITIES_CHECK_URL_NO_POSTCODE = countryPrefix + "mcd_multi_postcode_check/latitude/$LATITUDE/longitude/$LONGITUDE/ajax.html";

/** @const */
API.PRODUCT_DELIVERY_SLOTS_URL = countryPrefix + "mcd_home_delivery_slots/sProductId/$PRODUCT/sPostCode/$POSTCODE/ajax.html";
API.PRODUCT_DELIVERY_SLOTS_URL_WITH_COORDS = countryPrefix + "mcd_home_delivery_slots/sProductId/$PRODUCT/sPostCode/$POSTCODE/latitude/$LATITUDE/longitude/$LONGITUDE/ajax.html";

module.exports = API;
